import styles from './index.module.scss'
import classNames from 'classnames';
import { Checkbox, Row, Col, Input, Tag, Card } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useState, useEffect, useMemo } from 'react';
import DiscoverData from './components/discoverData'
import { mySidebar } from '@/apis/discover'
import { useSelector } from "react-redux";
import intl from 'react-intl-universal';

const MyShare = () => {
	const { userInfo } = useSelector(state => state.user)
	const token = useMemo(() => userInfo?.token, [userInfo])
	const [selectKeys, setSelectKeys] = useState(['Owned by me', 'Collected by me'])
	const [Keywords, setKeywords] = useState('')
	const [listTree, setListTree] = useState([])
	const selectPro = (list) => {
		setSelectKeys(list)
	}
	const getMySidebar = async () => {
		// const res = await mySidebar()
		mySidebar().then(res => {
			setListTree(res.data?.menuEntries || [])
		}).catch(res => {

		})
	}
	useEffect(() => {
		getMySidebar()
	}, [token])

	return (
		<div className={classNames("container", styles.myShareBox)} key="my-share">
			<h2>{intl.get("Share.My Resource")}</h2>
			<Row gutter={30}>
				<Col span={5}>
					<div>
						<Input onChange={(e) => setKeywords(e.target.value)} placeholder={intl.get("Search Resources By Title")} prefix={<SearchOutlined />} />
						<Card className={styles.searchBox} size="small" type="inner" title={intl.get("Filter")} >
							<Checkbox.Group
								className={styles.groupBox}
								onChange={selectPro}
								value={selectKeys}
							>
								{
									listTree.map((item, index) => {
										return (
											<div key={index + "my_share"}>
												<Checkbox className={styles.checkBox} value={item.id}>{item.name}</Checkbox>
												<Tag className={styles.tagBox} variant="filled" color="magenta">
													{item.count}
												</Tag>
											</div>
										)
									})
								}
							</Checkbox.Group>
						</Card>
					</div>
				</Col>
				<Col span={19}>
					<DiscoverData selectKeys={selectKeys} Keywords={Keywords} token={token} />
				</Col>
			</Row>
		</div>
	)
}
export default MyShare;